import {saveData, getData, clearData, findByID} from "../db/db_helper"

//load from DB
export const getOnlineCategories = async () =>{
    return await getData("categories") || []
}

export const getOffllineCategories = async () =>{
    return await getData("sync_categories") || []
}

export const getAllCategories = async () =>{
    const online = await getOnlineCategories()
    const offline = await getOffllineCategories()
    const all = [...online, ...offline]
    return all.sort((a, b) => a.index - b.index);
}

export const getCategorieById = async(id)=>{
    const online = await findByID("categories", id)
    const offline = await findByID("sync_categories", id)
    return online || offline || null
}

export const saveCategories = async (obj) =>{
    saveData("categories", obj)
}